import type {
  CarsListSuccess,
} from '@autobid/strapi-integration/typescript/auction/carsList'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import {
  auctionCarsQueryKey,
} from '@autobid/ui/composables/car/data/useAuctionCars'
import { AUCTION_CARS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAuctionCarsSocket'
import { useQueryClient } from '@tanstack/vue-query'

export function useAuctionCarsAuctionPause() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const auctionPause = () => {
    startListen({
      eventName: 'premium.AUCTION_PAUSE',
      callbackName: AUCTION_CARS_SOCKET_CALLBACK,
      callback: (event) => {
        const { auctionId } = event.context
        const queryKey = auctionCarsQueryKey.byAuctionId(auctionId)

        queryClient.setQueriesData(
          queryKey,
          (
            data?: CarsListSuccess['data']['items'],
          ): CarsListSuccess['data']['items'] | undefined => {
            if (!data) {
              return data
            }

            return {
              ...data,
              items: data.items.map((item) => {
                if (item.stage !== 'IN_AUCTION')
                  return item

                return {
                  ...item,
                  pausedHotbidStartTime: item.hotbidStartTime,
                  hotbidStartTime: null,
                }
              }),
            }
          },
        )
      },
    })
  }

  return { auctionPause }
}
